class ProductCarousel extends HTMLElement {
  constructor() {
    super();

    window.loadSwiper.then(({ Swiper, Navigation }) => {
      const swiperParams = {
        modules: [Navigation],
        slidesPerView: "auto",
        spaceBetween: 3,
        navigation: {
          nextEl: this.querySelector("[data-navigation-next]"),
          prevEl: this.querySelector("[data-navigation-previous]"),
        },
      };

      this.swiper = new Swiper(this, swiperParams);
    });
  }
}

if (!customElements.get("section-product-carousel")) {
  customElements.define("section-product-carousel", ProductCarousel);
}
